import { Dispatch } from 'redux';

import * as selectors from 'common.components/lesson-view.store/selectors';
import lessonActions from 'common.components/lesson/actions';
import * as lessonSelectors from 'common.components/lesson/selectors';
import { actions as problemsViewActions } from 'store/problems-view/actions';

export function removeProblemFromProblemViewAsync(args: { problemId: number; stackId?: number }) {
    return async function (dispatch: Dispatch<any>, getState: () => any) {
        const { problemId, stackId } = args;

        const problems = lessonSelectors.getLessonProblems(getState());
        const problemIndex = problems.findIndex((p) => p.problem?.id === problemId);

        const selectedProblem = selectors.getSelectedProblemLink(getState());

        const selectedProblemIndex = problems.indexOf(selectedProblem!);
        const isLastProblem = problems.length === 1;

        dispatch(lessonActions.removeProblemFromLesson({ problemId, stackId }));

        if (isLastProblem || selectedProblemIndex === -1) {
            dispatch(problemsViewActions.setSelectedProblemId(null));
        } else {
            const newSelectedProblemIndex =
                selectedProblemIndex === problems.length - 1 ? selectedProblemIndex - 1 : selectedProblemIndex + 1;
            const newSelectedProblemId = problems[newSelectedProblemIndex].problem?.id;

            if (newSelectedProblemId) {
                dispatch(problemsViewActions.setSelectedProblemId(newSelectedProblemId));
            }
        }

        lessonActions.showProblemDeletedToast({
            problemId,
            index: problemIndex,
            stackId: problems[problemIndex]?.from_theme,
        })(dispatch);
    };
}
